import React, { useState } from 'react';
import { FaTrain, FaTools, FaUserTie, FaCog, FaHardHat, FaStethoscope, FaGraduationCap, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaBolt, FaWrench, FaRuler, FaChartLine, FaShieldAlt, FaClipboardCheck } from 'react-icons/fa';

const RailwaysPage = () => {
  const [expandedExam, setExpandedExam] = useState(null);
  const [expandedDept, setExpandedDept] = useState(null);
  const [expandedPost, setExpandedPost] = useState(null);

  const railwayExams = [
    {
      id: 'rrb-ntpc',
      name: 'RRB NTPC (Non-Technical Popular Categories)',
      icon: <FaUserTie />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: 'Graduate/12th Pass',
      ageLimit: '18-33 years',
      salary: '₹21,700 - ₹69,100/month',
      description: 'Recruitment for various non-technical posts in Indian Railways',
      posts: ['Station Master', 'Goods Guard', 'Junior Accountant', 'Senior Commercial cum Ticket Clerk', 'Junior Clerk cum Typist', 'Accounts Clerk cum Typist', 'Senior Clerk cum Typist', 'Chief Commercial cum Ticket Clerk'],
      examPattern: [
        { stage: 'Stage 1 (CBT)', duration: '90 minutes', questions: '100', sections: 'General Awareness, Mathematics, General Intelligence & Reasoning' },
        { stage: 'Stage 2 (CBT)', duration: '90 minutes', questions: '120', sections: 'General Awareness, Mathematics, General Intelligence & Reasoning' },
        { stage: 'Typing Test/CBAT/Document Verification', duration: 'Varies', questions: 'N/A', sections: 'As per post requirement' }
      ],
      payLevel: 'Level 2 to Level 6'
    },
    {
      id: 'rrb-alp',
      name: 'RRB ALP (Assistant Loco Pilot)',
      icon: <FaTrain />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: '10th + ITI/Diploma',
      ageLimit: '18-28 years',
      salary: '₹35,400 - ₹1,12,400/month',
      description: 'Recruitment for Assistant Loco Pilot and Technicians',
      posts: ['Assistant Loco Pilot', 'Technician Grade I', 'Technician Grade II', 'Technician Grade III'],
      examPattern: [
        { stage: 'Stage 1 (CBT)', duration: '60 minutes', questions: '75', sections: 'Mathematics, General Intelligence, General Science, General Awareness' },
        { stage: 'Stage 2 (CBT - Part A)', duration: '120 minutes', questions: '175', sections: 'Mathematics, General Intelligence, Basic Science, Engineering Drawing, Trade Subjects' },
        { stage: 'CBAT/Document Verification', duration: 'Varies', questions: 'N/A', sections: 'Computer Based Aptitude Test for ALP' }
      ],
      payLevel: 'Level 5'
    },
    {
      id: 'rrb-group-d',
      name: 'RRB Group D',
      icon: <FaTools />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: '10th Pass',
      ageLimit: '18-33 years',
      salary: '₹18,000 - ₹56,900/month',
      description: 'Recruitment for Track Maintainer, Helper, Assistant Pointsman and other Group D posts',
      posts: ['Track Maintainer Grade IV', 'Helper/Assistant in various departments', 'Assistant Pointsman', 'Level-1 posts'],
      examPattern: [
        { stage: 'CBT (Computer Based Test)', duration: '90 minutes', questions: '100', sections: 'General Science, Mathematics, General Intelligence & Reasoning, General Awareness & Current Affairs' },
        { stage: 'Physical Efficiency Test (PET)', duration: 'N/A', questions: 'N/A', sections: 'Physical Standards' },
        { stage: 'Document Verification', duration: 'N/A', questions: 'N/A', sections: 'Certificate Verification' }
      ],
      payLevel: 'Level 1'
    },
    {
      id: 'rrb-je',
      name: 'RRB JE (Junior Engineer)',
      icon: <FaCog />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: 'B.E./B.Tech or Diploma',
      ageLimit: '18-33 years',
      salary: '₹35,400 - ₹1,12,400/month',
      description: 'Recruitment for Junior Engineers in various technical departments',
      posts: ['Junior Engineer (Civil)', 'Junior Engineer (Mechanical)', 'Junior Engineer (Electrical)', 'Junior Engineer (Electronics)', 'Junior Engineer (S&T)', 'Depot Material Superintendent', 'Chemical & Metallurgical Assistant'],
      examPattern: [
        { stage: 'Stage 1 (CBT)', duration: '90 minutes', questions: '100', sections: 'Mathematics, General Intelligence & Reasoning, General Awareness, General Science' },
        { stage: 'Stage 2 (CBT)', duration: '120 minutes', questions: '150', sections: 'General Awareness, Physics & Chemistry, Technical Abilities, Basics of Computers & Environment' },
        { stage: 'Document Verification', duration: 'N/A', questions: 'N/A', sections: 'Certificate Verification' }
      ],
      payLevel: 'Level 6'
    },
    {
      id: 'rrb-sse',
      name: 'RRB SSE (Senior Section Engineer)',
      icon: <FaHardHat />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: 'B.E./B.Tech',
      ageLimit: '18-42 years',
      salary: '₹44,900 - ₹1,42,400/month',
      description: 'Recruitment for Senior Section Engineers in technical departments',
      posts: ['Senior Section Engineer (Civil)', 'Senior Section Engineer (Electrical)', 'Senior Section Engineer (Mechanical)', 'Senior Section Engineer (S&T)'],
      examPattern: [
        { stage: 'Stage 1 (CBT)', duration: '90 minutes', questions: '100', sections: 'Mathematics, General Intelligence & Reasoning, General Awareness, General Science' },
        { stage: 'Stage 2 (CBT)', duration: '120 minutes', questions: '150', sections: 'General Awareness, Physics & Chemistry, Technical Abilities, Computer & Environment' },
        { stage: 'Document Verification', duration: 'N/A', questions: 'N/A', sections: 'Certificate Verification' }
      ],
      payLevel: 'Level 7'
    },
    {
      id: 'rrb-paramedical',
      name: 'RRB Paramedical Staff',
      icon: <FaStethoscope />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: 'Graduate/Diploma in Medical',
      ageLimit: '18-33 years',
      salary: '₹29,200 - ₹92,300/month',
      description: 'Recruitment for medical staff in Indian Railways',
      posts: ['Staff Nurse', 'Health & Malaria Inspector', 'Pharmacist', 'Lab Assistant', 'ECG Technician', 'Radiographer', 'Optometrist'],
      examPattern: [
        { stage: 'Stage 1 (CBT)', duration: '90 minutes', questions: '100', sections: 'General Awareness, General Intelligence, General Science, Technical Ability' },
        { stage: 'Stage 2 (CBAT/Skill Test)', duration: 'Varies', questions: 'N/A', sections: 'As per post requirement' },
        { stage: 'Document Verification', duration: 'N/A', questions: 'N/A', sections: 'Certificate Verification' }
      ],
      payLevel: 'Level 3 to Level 5'
    },
    {
      id: 'rrb-ministerial',
      name: 'RRB Ministerial & Isolated Categories',
      icon: <FaClipboardCheck />,
      conductedBy: 'Railway Recruitment Board',
      eligibility: 'Graduate',
      ageLimit: '18-33 years',
      salary: '₹25,500 - ₹81,100/month',
      description: 'Recruitment for ministerial and other isolated posts',
      posts: ['Junior Translator', 'Stenographer', 'Chief Law Assistant', 'Junior Law Assistant'],
      examPattern: [
        { stage: 'CBT (Computer Based Test)', duration: '90 minutes', questions: '100', sections: 'General Awareness, Reasoning, Mathematics, Professional Ability' },
        { stage: 'Skill Test/Interview', duration: 'Varies', questions: 'N/A', sections: 'As per post requirement' },
        { stage: 'Document Verification', duration: 'N/A', questions: 'N/A', sections: 'Certificate Verification' }
      ],
      payLevel: 'Level 4 to Level 6'
    }
  ];

  const departments = [
    {
      id: 'mechanical',
      name: 'Mechanical Department',
      icon: <FaCog />,
      description: 'Responsible for maintenance and repair of rolling stock',
      posts: [
        { role: 'Loco Pilot', eligibility: '10th + ITI', salary: '₹35,000-₹70,000', duties: 'Operating locomotives, ensuring safety' },
        { role: 'Assistant Loco Pilot', eligibility: '10th + ITI', salary: '₹35,400-₹1,12,400', duties: 'Assisting loco pilot, train operations' },
        { role: 'JE (Mechanical)', eligibility: 'Diploma/B.Tech', salary: '₹35,400-₹1,12,400', duties: 'Maintenance of locomotives and coaches' },
        { role: 'SSE (Mechanical)', eligibility: 'B.Tech', salary: '₹44,900-₹1,42,400', duties: 'Supervision of maintenance work' },
        { role: 'Technician (Fitter)', eligibility: '10th + ITI', salary: '₹21,700-₹69,100', duties: 'Repair and maintenance of mechanical parts' }
      ],
      workshops: ['Loco Sheds', 'Carriage & Wagon Workshops', 'Production Units']
    },
    {
      id: 'electrical',
      name: 'Electrical Department',
      icon: <FaBolt />,
      description: 'Handles electrical installations and traction systems',
      posts: [
        { role: 'JE (Electrical)', eligibility: 'Diploma/B.Tech (EEE)', salary: '₹35,400-₹1,12,400', duties: 'Electrical maintenance, power supply' },
        { role: 'SSE (Electrical)', eligibility: 'B.Tech (EEE)', salary: '₹44,900-₹1,42,400', duties: 'Supervision of electrical installations' },
        { role: 'Technician (Electrician)', eligibility: '10th + ITI', salary: '₹21,700-₹69,100', duties: 'Electrical repairs and maintenance' },
        { role: 'TRD Staff', eligibility: 'Diploma', salary: '₹29,200-₹92,300', duties: 'Traction related maintenance' }
      ],
      workshops: ['Electric Loco Sheds', 'TRD Workshops', 'Overhead Equipment Maintenance']
    },
    {
      id: 'civil',
      name: 'Civil Engineering Department',
      icon: <FaRuler />,
      description: 'Maintains tracks, bridges, buildings, and structures',
      posts: [
        { role: 'JE (Civil)', eligibility: 'Diploma/B.Tech (Civil)', salary: '₹35,400-₹1,12,400', duties: 'Track maintenance, construction supervision' },
        { role: 'SSE (Civil)', eligibility: 'B.Tech (Civil)', salary: '₹44,900-₹1,42,400', duties: 'Planning and supervision of civil works' },
        { role: 'Track Maintainer', eligibility: '10th Pass', salary: '₹18,000-₹56,900', duties: 'Track inspection and maintenance' },
        { role: 'Bridge Inspector', eligibility: 'Diploma', salary: '₹29,200-₹92,300', duties: 'Bridge inspection and maintenance' }
      ],
      workshops: ['Track Maintenance', 'Bridge Maintenance', 'Building Construction']
    },
    {
      id: 'signal-telecom',
      name: 'Signal & Telecommunication (S&T)',
      icon: <FaWrench />,
      description: 'Manages signaling systems and railway telecommunications',
      posts: [
        { role: 'JE (S&T)', eligibility: 'Diploma/B.Tech (ECE)', salary: '₹35,400-₹1,12,400', duties: 'Signal maintenance, telecom equipment' },
        { role: 'SSE (S&T)', eligibility: 'B.Tech (ECE)', salary: '₹44,900-₹1,42,400', duties: 'Supervision of signaling systems' },
        { role: 'Technician (Signal)', eligibility: '10th + ITI', salary: '₹21,700-₹69,100', duties: 'Signal equipment maintenance' },
        { role: 'Telecom Maintainer', eligibility: 'Diploma', salary: '₹29,200-₹92,300', duties: 'Telecommunication maintenance' }
      ],
      workshops: ['Signal Workshops', 'Telecom Maintenance Units', 'Electronic Interlocking Centers']
    },
    {
      id: 'operating',
      name: 'Operating Department (Traffic)',
      icon: <FaTrain />,
      description: 'Manages train operations and passenger services',
      posts: [
        { role: 'Station Master', eligibility: 'Graduate', salary: '₹35,400-₹1,12,400', duties: 'Station operations, train dispatch' },
        { role: 'Goods Guard', eligibility: 'Graduate', salary: '₹29,200-₹92,300', duties: 'Freight train operations' },
        { role: 'Assistant Station Master', eligibility: 'Graduate', salary: '₹29,200-₹92,300', duties: 'Assisting in station operations' },
        { role: 'Commercial Clerk', eligibility: 'Graduate', salary: '₹21,700-₹69,100', duties: 'Ticketing, passenger services' },
        { role: 'Ticket Collector', eligibility: 'Graduate', salary: '₹21,700-₹69,100', duties: 'Ticket checking, train management' }
      ],
      workshops: ['Station Management', 'Control Offices', 'Freight Terminals']
    },
    {
      id: 'accounts',
      name: 'Accounts Department',
      icon: <FaChartLine />,
      description: 'Financial management and accounting',
      posts: [
        { role: 'Junior Accountant', eligibility: 'Graduate + Commerce', salary: '₹29,200-₹92,300', duties: 'Accounting, financial records' },
        { role: 'Senior Clerk', eligibility: 'Graduate', salary: '₹29,200-₹92,300', duties: 'Accounts maintenance' },
        { role: 'Accounts Clerk', eligibility: 'Graduate', salary: '₹21,700-₹69,100', duties: 'Bill processing, record keeping' }
      ],
      workshops: ['Divisional Accounts Offices', 'Zonal Accounts Offices']
    },
    {
      id: 'medical',
      name: 'Medical Department',
      icon: <FaStethoscope />,
      description: 'Healthcare services for railway employees and passengers',
      posts: [
        { role: 'Staff Nurse', eligibility: 'B.Sc Nursing/GNM', salary: '₹29,200-₹92,300', duties: 'Patient care, medical assistance' },
        { role: 'Pharmacist', eligibility: 'D.Pharm/B.Pharm', salary: '₹29,200-₹92,300', duties: 'Medicine dispensing' },
        { role: 'Lab Technician', eligibility: 'DMLT/B.Sc MLT', salary: '₹29,200-₹92,300', duties: 'Laboratory tests' },
        { role: 'Health Inspector', eligibility: 'Graduate + Diploma', salary: '₹29,200-₹92,300', duties: 'Sanitation, health monitoring' }
      ],
      workshops: ['Railway Hospitals', 'Health Units', 'Mobile Health Units']
    },
    {
      id: 'security',
      name: 'Railway Protection Force (RPF)',
      icon: <FaShieldAlt />,
      description: 'Security and protection of railway property',
      posts: [
        { role: 'RPF Constable', eligibility: '10th/12th Pass', salary: '₹21,700-₹69,100', duties: 'Security, crowd management' },
        { role: 'RPF Sub-Inspector', eligibility: 'Graduate', salary: '₹35,400-₹1,12,400', duties: 'Security supervision' },
        { role: 'RPF Assistant Sub-Inspector', eligibility: 'Graduate', salary: '₹29,200-₹92,300', duties: 'Security operations' }
      ],
      workshops: ['RPF Posts', 'Railway Police Stations', 'Security Control Rooms']
    }
  ];

  const syllabus = {
    mathematics: {
      topics: [
        'Number Systems',
        'Decimals, Fractions, LCM & HCF',
        'Percentage',
        'Ratio and Proportion',
        'Square Roots and Cube Roots',
        'Average',
        'Simple and Compound Interest',
        'Profit and Loss',
        'Time and Work',
        'Time, Speed and Distance',
        'Mensuration (Area, Volume)',
        'Algebra (Linear Equations)',
        'Geometry (Triangles, Circles)',
        'Trigonometry (Basic)',
        'Statistics (Mean, Median, Mode)',
        'Data Interpretation'
      ]
    },
    reasoning: {
      topics: [
        'Analogies',
        'Alphabetical and Number Series',
        'Coding and Decoding',
        'Mathematical Operations',
        'Relationships',
        'Syllogism',
        'Jumbling',
        'Venn Diagram',
        'Data Interpretation',
        'Conclusions and Decision Making',
        'Similarities and Differences',
        'Analytical Reasoning',
        'Classification',
        'Direction Sense',
        'Statement and Arguments',
        'Assumption and Conclusion'
      ]
    },
    generalScience: {
      topics: [
        'Physics (Mechanics, Heat, Light, Sound, Electricity)',
        'Chemistry (Elements, Compounds, Acids & Bases, Metals & Non-metals)',
        'Biology (Human Body, Diseases, Nutrition)',
        'Environmental Science',
        'Scientific Inventions and Discoveries',
        'Scientific Terms',
        'Units and Measurements',
        'Energy Sources',
        'Computer Basics',
        'Space Technology'
      ]
    },
    generalAwareness: {
      topics: [
        'Current Affairs (National & International)',
        'Indian Geography',
        'Indian History',
        'Indian Polity and Constitution',
        'Indian Economy',
        'Sports',
        'Books and Authors',
        'Important Days and Dates',
        'Awards and Honors',
        'Science and Technology',
        'Railway-related Current Affairs',
        'Indian Culture and Heritage',
        'International Organizations',
        'Famous Personalities'
      ]
    },
    technical: {
      topics: [
        'Engineering Drawing',
        'Engineering Mechanics',
        'Strength of Materials',
        'Theory of Machines',
        'Manufacturing Processes',
        'Thermodynamics',
        'Electrical Circuits',
        'Machines and Measurements',
        'Electronics Basics',
        'Workshop Technology',
        'Material Science',
        'Basic Civil Engineering',
        'Environmental Studies',
        'Computer Applications'
      ]
    }
  };

  const careerProgression = [
    {
      level: 'Entry Level',
      posts: ['Track Maintainer', 'Helper', 'Assistant', 'Group D Posts'],
      payLevel: 'Level 1',
      salary: '₹18,000 - ₹56,900'
    },
    {
      level: 'Technician Level',
      posts: ['Technician Grade III', 'ALP', 'Commercial Clerk', 'Technician'],
      payLevel: 'Level 2-5',
      salary: '₹21,700 - ₹1,12,400'
    },
    {
      level: 'Junior Engineer/Supervisor',
      posts: ['Junior Engineer', 'Station Master', 'Junior Accountant'],
      payLevel: 'Level 6',
      salary: '₹35,400 - ₹1,12,400'
    },
    {
      level: 'Senior Engineer/Manager',
      posts: ['Senior Section Engineer', 'Divisional Engineer', 'Senior Manager'],
      payLevel: 'Level 7-10',
      salary: '₹44,900 - ₹1,60,000'
    },
    {
      level: 'Executive Level',
      posts: ['DRM', 'Chief Engineer', 'CSTE', 'CME'],
      payLevel: 'Level 11-14',
      salary: '₹1,18,500 - ₹2,25,000'
    }
  ];

  const benefits = [
    'Excellent salary with regular increments',
    'Job security and stability',
    'Pension benefits (7th Pay Commission)',
    'Free/Concessional railway passes',
    'Medical facilities for self and family',
    'Railway quarters/HRA',
    'Leave Travel Concession (LTC)',
    'Dearness Allowance (DA)',
    'Children education allowance',
    'Provident Fund and Gratuity',
    'Performance-linked bonus',
    'Promotion opportunities',
    'Training and skill development',
    'Sports and recreational facilities',
    'Cooperative societies benefits',
    'Post-retirement benefits'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Comprehensive Study Material',
      description: 'Complete books and notes for all railway exams with latest patterns'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Mock Tests',
      description: 'Unlimited CBT mock tests simulating actual railway exam environment'
    },
    {
      icon: <FaGraduationCap />,
      title: 'Experienced Faculty',
      description: 'Learn from railway officers and subject matter experts'
    },
    {
      icon: <FaClock />,
      title: 'Flexible Timings',
      description: 'Morning, evening and weekend batches for all students'
    },
    {
      icon: <FaTrophy />,
      title: 'Physical Test Training',
      description: 'Special PET preparation for ALP, Group D and RPF posts'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Document Guidance',
      description: 'Complete assistance for document verification process'
    }
  ];

  const preparationTips = [
    {
      section: 'Mathematics',
      tips: [
        'Master basic arithmetic and algebra',
        'Practice time and work problems daily',
        'Learn shortcut methods for quick calculations',
        'Focus on data interpretation',
        'Solve at least 50 questions daily'
      ]
    },
    {
      section: 'General Intelligence & Reasoning',
      tips: [
        'Practice puzzles and seating arrangements',
        'Master coding-decoding patterns',
        'Work on series completion daily',
        'Improve logical reasoning skills',
        'Time management is crucial'
      ]
    },
    {
      section: 'General Science',
      tips: [
        'Focus on NCERT books (Class 6-10)',
        'Understand basic physics formulas',
        'Learn chemistry reactions and elements',
        'Study human biology thoroughly',
        'Practice MCQs from previous papers'
      ]
    },
    {
      section: 'General Awareness',
      tips: [
        'Read newspapers daily',
        'Follow railway-related news',
        'Prepare last 6 months current affairs',
        'Study Indian geography and economy',
        'Make notes of important events'
      ]
    }
  ];

  const toggleExam = (id) => {
    setExpandedExam(expandedExam === id ? null : id);
  };

  const toggleDept = (id) => {
    setExpandedDept(expandedDept === id ? null : id);
  };

  const togglePost = (level) => {
    setExpandedPost(expandedPost === level ? null : level);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Indian Railways Examination Training</h1>
              <p className="lead mb-4">
                Join the world's 4th largest railway network. Comprehensive training for RRB NTPC, ALP, Group D, JE, and all railway recruitment exams. Secure your future with Indian Railways!
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Enroll Today</button>
              <button className="btn btn-outline-light btn-lg px-4">View Courses</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaTrain size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">1.3M+</h3>
              <p className="text-muted mb-0">Railway Employees</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">1.5L+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">17 Zones</h3>
              <p className="text-muted mb-0">Across India</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">₹18K-2L</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
        </div>
      </div>

      {/* Railway Exams */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Railway Recruitment Board Examinations</h2>
        <div className="row">
          <div className="col-9 mx-auto">
            {railwayExams.map((exam) => (
              <div key={exam.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => toggleExam(exam.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '1.8rem' }}>
                      {exam.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{exam.name}</h5>
                      <small className="text-muted">{exam.description}</small>
                    </div>
                  </div>
                  {expandedExam === exam.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedExam === exam.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Eligibility:</strong></p>
                        <p className="text-muted">{exam.eligibility}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Age Limit:</strong></p>
                        <p className="text-muted">{exam.ageLimit}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Salary:</strong></p>
                        <p className="text-success fw-bold">{exam.salary}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="mb-1"><strong>Pay Level:</strong></p>
                        <p className="text-muted">{exam.payLevel}</p>
                      </div>
                    </div>

                    <h6 className="fw-bold mb-3">Posts Available:</h6>
                    <div className="d-flex flex-wrap gap-2 mb-4">
                      {exam.posts.map((post, idx) => (
                        <span key={idx} className="badge bg-info">{post}</span>
                      ))}
                    </div>

                    <h6 className="fw-bold mb-3">Examination Pattern:</h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>Stage</th>
                            <th>Duration</th>
                            <th>Questions</th>
                            <th>Sections</th>
                          </tr>
                        </thead>
                        <tbody>
                          {exam.examPattern.map((pattern, idx) => (
                            <tr key={idx}>
                              <td className="fw-semibold">{pattern.stage}</td>
                              <td>{pattern.duration}</td>
                              <td>{pattern.questions}</td>
                              <td>{pattern.sections}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Departments */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Railway Departments & Job Roles</h2>
          <div className="row">
            <div className="col-12">
              {departments.map((dept) => (
                <div key={dept.id} className="card mb-3 border-0 shadow-sm">
                  <div 
                    className="card-header d-flex justify-content-between align-items-center"
                    onClick={() => toggleDept(dept.id)}
                    style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  >
                    <div className="d-flex align-items-center">
                      <div className="text-primary me-3" style={{ fontSize: '1.5rem' }}>
                        {dept.icon}
                      </div>
                      <div>
                        <h5 className="mb-1 fw-bold">{dept.name}</h5>
                        <small className="text-muted">{dept.description}</small>
                      </div>
                    </div>
                    {expandedDept === dept.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {expandedDept === dept.id && (
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="table-light">
                            <tr>
                              <th>Role/Position</th>
                              <th>Eligibility</th>
                              <th>Salary Range</th>
                              <th>Key Duties</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dept.posts.map((post, idx) => (
                              <tr key={idx}>
                                <td className="fw-semibold">{post.role}</td>
                                <td>{post.eligibility}</td>
                                <td className="text-success">{post.salary}</td>
                                <td><small>{post.duties}</small></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {dept.workshops && (
                        <div className="mt-3">
                          <h6 className="fw-bold mb-2">Work Locations:</h6>
                          <div className="d-flex flex-wrap gap-2">
                            {dept.workshops.map((workshop, idx) => (
                              <span key={idx} className="badge bg-secondary">{workshop}</span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Syllabus Section */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Complete Syllabus Coverage</h2>
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-primary text-white">
                <div className="d-flex align-items-center">
                  <FaBook className="me-2" />
                  <h5 className="mb-0">Mathematics</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.mathematics.topics.map((topic, idx) => (
                    <div key={idx} className="col-md-6 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-success text-white">
                <div className="d-flex align-items-center">
                  <FaBook className="me-2" />
                  <h5 className="mb-0">General Intelligence & Reasoning</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.reasoning.topics.map((topic, idx) => (
                    <div key={idx} className="col-md-6 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-info text-white">
                <div className="d-flex align-items-center">
                  <FaBook className="me-2" />
                  <h5 className="mb-0">General Science</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.generalScience.topics.map((topic, idx) => (
                    <div key={idx} className="col-12 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-warning text-dark">
                <div className="d-flex align-items-center">
                  <FaBook className="me-2" />
                  <h5 className="mb-0">General Awareness & Current Affairs</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.generalAwareness.topics.map((topic, idx) => (
                    <div key={idx} className="col-md-6 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-secondary text-white">
                <div className="d-flex align-items-center">
                  <FaBook className="me-2" />
                  <h5 className="mb-0">Technical Subjects (For JE/ALP)</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {syllabus.technical.topics.map((topic, idx) => (
                    <div key={idx} className="col-md-4 mb-2">
                      <FaCheckCircle className="text-success me-2" size={12} />
                      <small>{topic}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Career Progression */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Career Growth Path in Indian Railways</h2>
          <div className="row g-4">
            {careerProgression.map((career, idx) => (
              <div key={idx} className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-md-3">
                        <div className="bg-primary text-white rounded p-3 text-center">
                          <h5 className="fw-bold mb-0">{career.level}</h5>
                          <small>{career.payLevel}</small>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <h6 className="fw-bold mb-2">Positions:</h6>
                        <div className="d-flex flex-wrap gap-2">
                          {career.posts.map((post, pIdx) => (
                            <span key={pIdx} className="badge bg-info">{post}</span>
                          ))}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <h6 className="fw-bold mb-2">Salary Range:</h6>
                        <h4 className="text-success mb-0">{career.salary}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Railway Zones */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">17 Railway Zones of India</h2>
        <div className="row g-3">
          {[
            { zone: 'Northern Railway (NR)', hq: 'New Delhi' },
            { zone: 'North Eastern Railway (NER)', hq: 'Gorakhpur' },
            { zone: 'Northeast Frontier Railway (NFR)', hq: 'Maligaon, Guwahati' },
            { zone: 'Eastern Railway (ER)', hq: 'Kolkata' },
            { zone: 'South Eastern Railway (SER)', hq: 'Kolkata' },
            { zone: 'South Central Railway (SCR)', hq: 'Secunderabad' },
            { zone: 'Southern Railway (SR)', hq: 'Chennai' },
            { zone: 'Central Railway (CR)', hq: 'Mumbai' },
            { zone: 'Western Railway (WR)', hq: 'Mumbai' },
            { zone: 'South Western Railway (SWR)', hq: 'Hubli' },
            { zone: 'North Western Railway (NWR)', hq: 'Jaipur' },
            { zone: 'West Central Railway (WCR)', hq: 'Jabalpur' },
            { zone: 'North Central Railway (NCR)', hq: 'Prayagraj' },
            { zone: 'South East Central Railway (SECR)', hq: 'Bilaspur' },
            { zone: 'East Coast Railway (ECoR)', hq: 'Bhubaneswar' },
            { zone: 'East Central Railway (ECR)', hq: 'Hajipur' },
            { zone: 'South Coast Railway (SCoR)', hq: 'Visakhapatnam' }
          ].map((railway, idx) => (
            <div key={idx} className="col-md-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center">
                    <FaTrain className="text-primary me-3 flex-shrink-0" size={24} />
                    <div>
                      <h6 className="mb-1 fw-bold">{railway.zone}</h6>
                      <small className="text-muted">Headquarters: {railway.hq}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Preparation Tips */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Section-wise Preparation Tips</h2>
          <div className="row g-4">
            {preparationTips.map((tip, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow h-100">
                  <div className="card-header bg-gradient text-white" style={{ background: `linear-gradient(135deg, ${['#667eea', '#f093fb', '#4facfe', '#43e97b'][idx]} 0%, ${['#764ba2', '#f5576c', '#00f2fe', '#38f9d7'][idx]} 100%)` }}>
                    <h5 className="mb-0 fw-bold">{tip.section}</h5>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      {tip.tips.map((t, tIdx) => (
                        <li key={tIdx} className="mb-3">
                          <FaCheckCircle className="text-success me-2" />
                          {t}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Benefits */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Benefits of Railway Career</h2>
        <div className="row g-3">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body d-flex align-items-center p-3">
                  <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                  <p className="mb-0">{benefit}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Railway Training?</h2>
          <div className="row g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Physical Standards */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Physical Efficiency Test (PET) Standards</h2>
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-primary h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">For Male Candidates</h5>
              </div>
              <div className="card-body">
                <table className="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <td><strong>Running (1600m)</strong></td>
                      <td>Within 5 minutes 45 seconds</td>
                    </tr>
                    <tr>
                      <td><strong>Height</strong></td>
                      <td>157.5 cm (General), 152.5 cm (ST)</td>
                    </tr>
                    <tr>
                      <td><strong>Chest</strong></td>
                      <td>Minimum 81 cm (expansion 5 cm)</td>
                    </tr>
                    <tr>
                      <td><strong>Weight</strong></td>
                      <td>Proportionate to height and age</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-success h-100">
              <div className="card-header bg-success text-white">
                <h5 className="mb-0">For Female Candidates</h5>
              </div>
              <div className="card-body">
                <table className="table table-sm mb-0">
                  <tbody>
                    <tr>
                      <td><strong>Running (1000m)</strong></td>
                      <td>Within 5 minutes 40 seconds</td>
                    </tr>
                    <tr>
                      <td><strong>Height</strong></td>
                      <td>152 cm (General), 147 cm (ST)</td>
                    </tr>
                    <tr>
                      <td><strong>Chest</strong></td>
                      <td>Not applicable</td>
                    </tr>
                    <tr>
                      <td><strong>Weight</strong></td>
                      <td>Proportionate to height and age</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="alert alert-info mt-4">
          <strong>Note:</strong> Physical standards vary slightly based on posts (ALP, Group D, RPF). Relaxations available for reserved categories.
        </div>
      </div>

      {/* Important Information */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Important Information</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <FaGraduationCap size={50} className="text-primary mx-auto mb-3" />
                <h5 className="fw-bold">Educational Qualification</h5>
                <hr />
                <ul className="list-unstyled text-start small">
                  <li className="mb-2">✓ Group D: 10th Pass</li>
                  <li className="mb-2">✓ ALP: 10th + ITI</li>
                  <li className="mb-2">✓ NTPC: Graduate/12th</li>
                  <li className="mb-2">✓ JE: Diploma/B.Tech</li>
                  <li className="mb-2">✓ SSE: B.E./B.Tech</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <FaClock size={50} className="text-success mx-auto mb-3" />
                <h5 className="fw-bold">Exam Frequency</h5>
                <hr />
                <ul className="list-unstyled text-start small">
                  <li className="mb-2">✓ RRB NTPC: Once a year</li>
                  <li className="mb-2">✓ RRB ALP: Once in 1-2 years</li>
                  <li className="mb-2">✓ RRB Group D: Once a year</li>
                  <li className="mb-2">✓ RRB JE: Once in 1-2 years</li>
                  <li className="mb-2">✓ Notifications on www.rrbcdg.gov.in</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow text-center p-4">
                <FaTrophy size={50} className="text-info mx-auto mb-3" />
                <h5 className="fw-bold">Selection Process</h5>
                <hr />
                <ul className="list-unstyled text-start small">
                  <li className="mb-2">✓ Computer Based Test (CBT)</li>
                  <li className="mb-2">✓ Physical Efficiency Test (if applicable)</li>
                  <li className="mb-2">✓ Document Verification</li>
                  <li className="mb-2">✓ Medical Examination</li>
                  <li className="mb-2">✓ Merit-based final selection</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Join Indian Railways?</h2>
            <p className="lead mb-4">
              Start your preparation today with our comprehensive training programs for all railway exams
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Download Study Material</button>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="bg-dark text-white py-4">
        <div className="container text-center">
          <p className="mb-2">
            <strong>Note:</strong> Railway Recruitment Board conducts examinations for various posts throughout the year across 21 RRBs in India
          </p>
          <p className="mb-0 small text-muted">
            For official notifications: Visit www.rrbcdg.gov.in | Individual RRB websites
          </p>
        </div>
      </div>
    </div>
  );
};

export default RailwaysPage;